var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProbuildstatsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "probuildstats-logo_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.25.25h17.5v17.5H.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#probuildstats-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76.485A.44.44 0 015.15.25h3.075c.333 0 .545.358.389.654L6.315 5.258a.449.449 0 00-.045.287l2.056 11.68c.09.518-.625.74-.836.26L2.257 5.591a.45.45 0 01.014-.39L4.76.485zM12.88.25a.44.44 0 01.388.237l2.485 4.733c.07.132.07.29 0 .422l-2.485 4.733a.44.44 0 01-.389.237H9.8a.448.448 0 01-.389-.66l2.263-4.31a.454.454 0 000-.422L9.41.909A.448.448 0 019.8.25h3.08z",
    fill: "#5C5C8E"
  }))));
}
export default __webpack_public_path__ + "static/svg/probuildstats-logo.svg";
export { SvgProbuildstatsLogo as ReactComponent };